import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMergedUtmParams, saveUtmParams, buildUrlWithUtm } from '@/lib/utm';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

/**
 * 流入パターンを判定して文字列を返す
 */
const getTrafficType = (utm: { source?: string | null; medium?: string | null }): string => {
  if (!utm.source && !utm.medium) return 'organic';
  if (utm.source === 'meta' && utm.medium === 'paid_social') return 'meta_ad';
  if (utm.source === 'tiktok' && utm.medium === 'paid_social') return 'tiktok_ad';
  if (utm.source === 'meta' && utm.medium === 'organic') return 'meta_organic';
  if (utm.source === 'tiktok' && utm.medium === 'organic') return 'tiktok_organic';
  return 'other';
};

export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // UTMパラメータを保存
    saveUtmParams();
    
    if (typeof window !== 'undefined' && window.gtag) {
      const utmParams = getMergedUtmParams();
      // UTMパラメータを含む完全なURLを構築
      const pageLocation = buildUrlWithUtm(location.pathname);
      
      window.gtag('config', 'G-KWTRMWTR0J', {
        page_path: location.pathname + location.search,
        page_location: pageLocation || window.location.href,
        // UTMパラメータを含める
        utm_source: utmParams.source || 'direct',
        utm_medium: utmParams.medium || 'none',
        utm_campaign: utmParams.campaign || '',
        utm_content: utmParams.content || '',
        traffic_type: getTrafficType(utmParams),
      });
    }
  }, [location]);

  return null;
}

